import pizzaImg from '../assets/img/placeholder images/image (5).png';
import burgerImg from '../assets/img/placeholder images/image (1).png';
import dishImg from '../assets/img/placeholder images/image (4).png';
import coldDrinkImg from '../assets/img/placeholder images/image (3).png';
import coffeeCupImg from '../assets/img/placeholder images/image (2).png';

/**
 * Demo popular dishes shown on the home page when the store
 * has not marked any menu items as popular yet.
 */
export const popularDishesPlaceholder = [
    {
        id: 'placeholder-pizza',
        name: {
            en: 'Margherita Pizza',
            tr: 'Margherita Pizza',
            fa: 'پیتزا مارگاریتا',
            ar: 'بيتزا مارغريتا',
            el: 'Πίτσα Μαργαρίτα',
            ru: 'Пицца Маргарита',
        },
        description: {
            en: 'Classic tomato, mozzarella, and fresh basil on a crisp handmade crust.',
            tr: 'Çıtır el yapımı hamur üzerinde klasik domates, mozzarella ve taze fesleğen.',
            fa: 'گوجه‌فرنگی کلاسیک، موزارلا و ریحان تازه روی خمیر ترد دست‌ساز.',
            ar: 'طماطم كلاسيكية وموزاريلا وريحان طازج على عجينة مقرمشة يدوية.',
            el: 'Κλασική ντομάτα, μοτσαρέλα και φρέσκος βασιλικός σε τραγανή χειροποίητη ζύμη.',
            ru: 'Классические томаты, моцарелла и свежий базилик на хрустящем тесте.',
        },
        price: 18,
        category: 'pizza',
        imageUrl: [pizzaImg],
        availability: true,
        isPopular: true,
        status: 'active',
        variants: [],
    },
    {
        id: 'placeholder-burger',
        name: {
            en: 'Classic Cheeseburger',
            tr: 'Klasik Cheeseburger',
            fa: 'چیزبرگر کلاسیک',
            ar: 'تشيز برجر كلاسيكي',
            el: 'Κλασικό Cheeseburger',
            ru: 'Классический чизбургер',
        },
        description: {
            en: 'Juicy beef patty, melted cheese, lettuce, and house sauce in a toasted bun.',
            tr: 'Sulu dana köfte, erimiş peynir, marul ve ev sosu ile kızarmış ekmek arasında.',
            fa: 'همبرگر گوشت آبدار، پنیر ذوب‌شده، کاهو و سس مخصوص در نان تست‌شده.',
            ar: 'قرص لحم عصاري وجبن ذائب وخس وصلصة المنزل في خبز محمص.',
            el: 'Ζουμερό μπιφτέκι, λιωμένο τυρί, μαρούλι και σπιτική σάλτσα σε καβουρδισμένο ψωμάκι.',
            ru: 'Сочная котлета, расплавленный сыр, салат и фирменный соус в поджаренной булочке.',
        },
        price: 14,
        category: 'burger',
        imageUrl: [burgerImg],
        availability: true,
        isPopular: true,
        status: 'active',
        variants: [],
    },
    {
        id: 'placeholder-dish',
        name: {
            en: "Chef's Special Plate",
            tr: 'Şefin Özel Tabağı',
            fa: 'بشقاب ویژه سرآشپز',
            ar: 'طبق الشيف الخاص',
            el: 'Ειδικό Πιάτο Σεφ',
            ru: 'Фирменное блюдо шефа',
        },
        description: {
            en: 'A hearty main plate with seasonal sides, prepared daily by our kitchen.',
            tr: 'Mutfağımızın her gün hazırladığı mevsimsel garnitürlü doyurucu ana yemek.',
            fa: 'بشقاب اصلی سیرکننده با مخلفات فصلی که هر روز در آشپزخانه ما آماده می‌شود.',
            ar: 'طبق رئيسي دسم مع جانبيات موسمية يُعد يومياً في مطبخنا.',
            el: 'Χορταστικό κυρίως πιάτο με εποχιακά συνοδευτικά, καθημερινά από την κουζίνα μας.',
            ru: 'Сытное основное блюдо с сезонными гарнирами, которое мы готовим каждый день.',
        },
        price: 22,
        category: 'mainDishes',
        imageUrl: [dishImg],
        availability: true,
        isPopular: true,
        status: 'active',
        variants: [],
    },
    {
        id: 'placeholder-cold-drink',
        name: {
            en: 'Fresh Lemonade',
            tr: 'Taze Limonata',
            fa: 'لیموناد تازه',
            ar: 'ليمونادة طازجة',
            el: 'Φρέσκια Λεμονάδα',
            ru: 'Свежий лимонад',
        },
        description: {
            en: 'Chilled lemonade made with fresh citrus and a touch of mint.',
            tr: 'Taze narenciye ve bir tutam nane ile hazırlanan soğuk limonata.',
            fa: 'لیموناد خنک با مرکبات تازه و کمی نعناع.',
            ar: 'ليمونادة باردة محضرة من الحمضيات الطازجة مع لمسة نعناع.',
            el: 'Δροσερή λεμονάδα με φρέσκα εσπεριδοειδή και μια νότα μέντας.',
            ru: 'Охлаждённый лимонад из свежих цитрусовых с лёгкой нотой мяты.',
        },
        price: 6,
        category: 'coldDrink',
        imageUrl: [coldDrinkImg],
        availability: true,
        isPopular: true,
        status: 'active',
        variants: [],
    },
    {
        id: 'placeholder-coffee',
        name: {
            en: 'Signature Coffee',
            tr: 'İmza Kahve',
            fa: 'قهوه ویژه',
            ar: 'قهوة مميزة',
            el: 'Καφές Υπογραφής',
            ru: 'Фирменный кофе',
        },
        description: {
            en: 'Rich espresso-based coffee, finished with a silky crema.',
            tr: 'İpeksi crema ile tamamlanan zengin espresso bazlı kahve.',
            fa: 'قهوه غلیظ بر پایه اسپرسو با کرمای ابریشمی.',
            ar: 'قهوة غنية على أساس الإسبريسو بطبقة كريمة حريرية.',
            el: 'Πλούσιος καφές εσπρέσο με βελούδινη κρέμα.',
            ru: 'Насыщенный кофе на основе эспрессо с шелковистой крема.',
        },
        price: 5,
        category: 'hotCoffee',
        imageUrl: [coffeeCupImg],
        availability: true,
        isPopular: true,
        status: 'active',
        variants: [],
    },
];
